/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Other_EditInputs */

const en_footer_other_edit = /** @type {(inputs: Footer_Other_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit original English content`)
};

/**
* | output |
* | --- |
* | "Edit original English content" |
*
* @param {Footer_Other_EditInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_other_edit = /** @type {((inputs?: Footer_Other_EditInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Other_EditInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_other_edit(inputs)
});